module.exports = __webpack_public_path__ + "img/icn_x_mark.c2401184.svg";